function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7109 12.5C20.7109 13.2031 20.1641 13.75 19.5 13.75L7.50781 13.75L11.6094 17.8906C12.1172 18.3594 12.1172 19.1797 11.6094 19.6484C11.375 19.8828 11.0625 20 10.75 20C10.3984 20 10.0859 19.8828 9.85156 19.6484L3.60156 13.3984C3.09375 12.9297 3.09375 12.1094 3.60156 11.6406L9.85156 5.39062C10.3203 4.88281 11.1406 4.88281 11.6094 5.39062C12.1172 5.85937 12.1172 6.67969 11.6094 7.14844L7.50781 11.25L19.5 11.25C20.1641 11.25 20.7109 11.8359 20.7109 12.5Z"
});

function SvgBackAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackAlt);
export default __webpack_public_path__ + "static/media/back-alt.e5b4165f.svg";
export { ForwardRef as ReactComponent };